// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.46.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".checkbox.c-field{padding:0}.checkbox__text>*{display:block;margin-left:3px}.checkbox__slot{margin-top:3px}.checkbox.is-indeterminate .checkbox__text::before{background-color:var(--bg-selected-intense);border-color:var(--bg-selected-intense)}.checkbox.is-indeterminate .checkbox__text::after{display:block;position:absolute;left:3px;top:50%;width:10px;height:2px;background-color:var(--shade-1);margin-top:-1px;content:\"\"}", ""]);
// Exports
module.exports = exports;
